//hooks
import { useState } from "react";
import  { NotificationConsumer } from "./context/NotificationContext";

//tranlsate
import { useTranslation } from 'react-i18next';

export const useApi = (apiFunc: (params?: any, data?: any) => Promise<any>, method:string) => {
  const {t} = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const { setNoteMessage, setShowMessage, setStatusCode } = NotificationConsumer();

  const HandlerApi = async (params?: any, data?: any) => {
    setLoading(true);
    setError(false);
    try {
      const result = await apiFunc(params, data);
      if (method !== "GET") {
        if(result.success) {
            // setNoteMessage(result.message)
            setNoteMessage(t("the_request_sent_successfully"))
            setShowMessage(true)
            setStatusCode(result.code)
        }
        else {
          setNoteMessage(t("the_request_not_sent"))
          setShowMessage(true)
          setStatusCode(result.code)
        }
      }
      return result;
    } 
    catch (err: any) {
      setError(true);
      if (method !== "GET") {
        const msg = err?.response?.data?.message;
        const status = err?.response?.status || 500;
        setNoteMessage(msg);
        setStatusCode(status);
        setShowMessage(true);
      }
      return {data: null};
    } finally {
      setLoading(false);
    }
  };

  return {loading, error,  HandlerApi };
};
